// extracted by mini-css-extract-plugin
module.exports = {"followMe":"lu","linkItem":"lv","linkItemWrap":"lw","title":"lx","linkAppItemWrap":"ly","iconWrap":"lz","mfollowMe":"lA","miconWrap":"lB","followMe-dark":"lC","followMeDark":"lC"};